<template>
  <nav>
    <ul class="flex space-x-4 xl:block xl:space-x-0 mb-2">
      <li>
        <RouterLink to="/loyalty-programme/rewards">{{ $t("navbar.loyalty-programme-rewards") }}</RouterLink>
      </li>
      <li>
        <RouterLink to="/loyalty-programme/history">{{ $t("navbar.loyalty-programme-history") }}</RouterLink>
      </li>
      <li>
        <RouterLink to="/loyalty-programme/favourites">{{ $t("navbar.loyalty-programme-favourites") }}</RouterLink>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
</script>

<style lang="postcss">
  .router-link-active {
    @apply text-primary;
  }
</style>
